class DlPageScanX extends HTMLElement {
    constructor() {
        super();

        this.video = null;
        this.controlsWrapper = null;
        this.playButton = null;
        this.handlePlayClick = this.handlePlayClick.bind(this);
        this.syncPlayState = this.syncPlayState.bind(this);
    }

    connectedCallback() {
        this.controlsWrapper = this.querySelector('.dl-page-scan-X-content-left-controls');
        this.playButton = this.querySelector('.dl-page-scan-X-control-play');
        this.video = this.getActiveVideo();

        if (!this.video || !this.playButton) {
            this.hideControls();
            return;
        }

        this.video.muted = true;
        this.video.play().catch(() => {
            /* 浏览器阻止自动播放时，保持暂停状态 */
        });

        this.playButton.addEventListener('click', this.handlePlayClick);

        this.resizeHandler = () => {
            const activeVideo = this.getActiveVideo();
            if (activeVideo && activeVideo !== this.video) {
                this.detachVideoListeners();
                this.video = activeVideo;
                this.video.muted = true;
                this.video.play().catch(() => {
                    /* 浏览器阻止自动播放时，保持暂停状态 */
                });
                this.attachVideoListeners();
                this.syncPlayState();
            }
        };

        window.addEventListener('resize', this.resizeHandler);

        this.attachVideoListeners();

        this.syncPlayState();
    }

    disconnectedCallback() {
        if (this.playButton) {
            this.playButton.removeEventListener('click', this.handlePlayClick);
        }

        this.detachVideoListeners();

        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
            this.resizeHandler = null;
        }
    }

    getActiveVideo() {
        const desktopVideo = this.querySelector('.dl-page-scan-X-content-left video.dl-hidden-mobile');
        const mobileVideo = this.querySelector('.dl-page-scan-X-content-left video.dl-hidden-desktop');

        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const candidate = isDesktop ? desktopVideo : mobileVideo;

        return candidate || desktopVideo || mobileVideo;
    }

    attachVideoListeners() {
        if (!this.video) return;

        this.video.addEventListener('play', this.syncPlayState);
        this.video.addEventListener('pause', this.syncPlayState);
        this.video.addEventListener('ended', this.syncPlayState);
        this.video.addEventListener('click', this.handlePlayClick);
    }

    detachVideoListeners() {
        if (!this.video) return;

        this.video.removeEventListener('play', this.syncPlayState);
        this.video.removeEventListener('pause', this.syncPlayState);
        this.video.removeEventListener('ended', this.syncPlayState);
        this.video.removeEventListener('click', this.handlePlayClick);
    }

    hideControls() {
        if (this.controlsWrapper) {
            this.controlsWrapper.classList.add('dl-page-scan-X-controls-hidden');
        }
    }

    handlePlayClick() {
        if (!this.video) return;

        if (this.video.paused || this.video.ended) {
            const playPromise = this.video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {
                    /* ignore autoplay restrictions */
                });
            }
        } else {
            this.video.pause();
        }
    }

    syncPlayState() {
        if (!this.playButton || !this.video) return;

        const isPaused = this.video.paused || this.video.ended;
        this.playButton.classList.toggle('is-paused', isPaused);
        this.playButton.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
        this.playButton.setAttribute('aria-label', isPaused ? '播放视频' : '暂停视频');
    }
}

if (!customElements.get('dl-page-scan-x')) {
    customElements.define('dl-page-scan-x', DlPageScanX);
}

